import React from 'react';
import styles from './Testimonials.module.scss';
import { classNameGenerator, clsx } from '@/utils';
import { useAppSelector } from '@/hooks';
import Slider from "react-slick";

const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 1500,
    swipeToSlide: true,
    centerPadding: '20px',
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                centerMode: false
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1.2,
                infinite: false,
                centerMode: true,
                centerPadding: '30px'
            }
        }
    ]
};

const Testimonials = () => {
    const cls = classNameGenerator(styles)
    const { data } = useAppSelector((state) => state.healthProgramV1);

    if (!data?.testimonials) {
        return <></>
    }

    const { userReviews, athleteData } = data?.testimonials || {}



    return (
        <div className={cls('testimonial-page')}>
            <section className={cls('user-testimonials')}>
                <div className={clsx(cls('container'),cls('container1'))}>
                    <h2>Trusted by thousands, everyday.</h2>
                    <p className={cls('subtitle')}>Real people, real results. See how clean, effective formulas fit into real routines</p>

                    <div className={cls('testimonial-slider')}>
                        {userReviews.map((rev, i) => (
                            <div key={i} className={cls('review-card')}>
                                <img src="https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/quote-right_1-0866c000239d4cd18929ee19a56aceec.png" className={cls('quote-icon')} />
                                <p className={cls('review-text')}>{rev.text}</p>
                                <div className={cls('user-info')}>
                                    <img src="https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/Container_13-27604485ad4e4eddbab21b8378c430a5.png" className={cls('avatar')} />
                                    <div className={cls('details')}>
                                        <strong>{rev.author}</strong>
                                        <span>{rev.age}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className={cls('athlete-spotlight')}>
                <div className={cls('container')}>
                    <h2>Trusted by Athletes</h2>
                    <p className={cls('subtitle')}>From elite competition to everyday training, Shyft fuels performance at every level.</p>

                    <div className={cls('athlete-grid')}>
                        <Slider {...settings}>
                            {athleteData.map((athlete, i) => (
                                <div key={i} className={cls('athlete-card')}>
                                    <div className={cls('image-container')}>
                                        <img src={athlete.img} alt={athlete.name} />
                                    </div>
                                    <div className={cls('athlete-content')}>
                                        <span className={cls('role')}>{athlete.role}</span>
                                        <h3>{athlete.name}</h3>
                                        <p className={cls('achievement')}>{athlete.achievement}</p>
                                        <p className={cls('quote')}>"{athlete.quote}"</p>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Testimonials;